
const _console = {
  log: function( ...args ) {
    console.log.apply( console, args );
  },
  warn: function( ...args ) {
    console.warn.apply( console, args );
  },
  error: function( ...args ) {
    console.error.apply( console, args );
  },
};

export default _console;
